import React, { useState, useEffect } from "react";
import "./iTiXBix.css";
import Gfooter from "../Gfooter.js";
import HowItWorks from "./HowItWorks.jsx";
import HeroSection from "./ITiBizherosection.jsx";
import ITixpos from "./ITixpos.jsx";

import AOS from "aos";
import "aos/dist/aos.css";

const IMAGES = {
  hero: "/iTiXBix_img/simplify.png",
  pos: "/iTiXBix_img/Lightning-Fast.png",
  inventory: "/iTiXBix_img/Real-time.png",
  payments: "/iTiXBix_img/Flexible_biling.png",
  dashboard: "/iTiXBix_img/CompleteBusiness.png",
};

const LINKS = {
  start: "#get-started",
  demo: "#demo",
};

/* ============================================================
   ICONS
   ============================================================ */

const ICONS = {
  store: (
    <>
      <path d="M3 9l1-5h16l1 5" />
      <path d="M4 9v11h16V9" />
      <path d="M9 20v-6h6v6" />
      <path d="M3 9a3 3 0 0 0 6 0 3 3 0 0 0 6 0 3 3 0 0 0 6 0" />
    </>
  ),
  phone: (
    <>
      <rect x="5" y="2" width="14" height="20" rx="2" />
      <path d="M12 18h.01" />
    </>
  ),
  shirt: (
    <path d="M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z" />
  ),
  wrench: (
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
  ),
  truck: (
    <>
      <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" />
      <path d="M15 18H9" />
      <path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14" />
      <circle cx="17" cy="18" r="2" />
      <circle cx="7" cy="18" r="2" />
    </>
  ),
  headset: (
    <path d="M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3" />
  ),
  sliders: (
    <path d="M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6" />
  ),
  shield: (
    <>
      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
      <path d="m9 12 2 2 4-4" />
    </>
  ),
  book: (
    <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20" />
  ),
  box: (
    <>
      <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
      <path d="m3.3 7 8.7 5 8.7-5" />
      <path d="M12 22V12" />
    </>
  ),
  receipt: (
    <>
      <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z" />
      <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8M12 6v2M12 16v2" />
    </>
  ),
  chart: (
    <>
      <path d="M3 3v18h18" />
      <path d="m19 9-5 5-4-4-3 3" />
    </>
  ),
};

const Icon = ({ name, size = 28 }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {ICONS[name]}
  </svg>
);

/* ============================================================
   SHARED COMPONENTS
   ============================================================ */

const Frame = ({ src, alt, tag }) => (
  <div
    className="ib-frame"
    data-aos="zoom-in"
    data-aos-duration="1100"
    data-aos-easing="ease-out-cubic"
  >
    <div className="ib-frame__inner">
      {tag && <span className="ib-frame__tag">{tag}</span>}

      <img
        src={src}
        alt={alt}
        loading="lazy"
        className="ib-frame__img"
      />
    </div>
  </div>
);

const SectionHead = ({ pill, title, subtitle }) => (
  <header className="ib-head">
    <span
      className="ib-pill"
      data-aos="fade-down"
      data-aos-duration="800"
    >
      {pill}
    </span>

    <h2
      className="ib-title"
      data-aos="fade-up"
      data-aos-delay="100"
      data-aos-duration="1000"
    >
      {title}
    </h2>

    <span
      className="ib-underline"
      data-aos="zoom-in"
      data-aos-delay="250"
      data-aos-duration="900"
    />

    <p
      className="ib-subtitle"
      data-aos="fade-up"
      data-aos-delay="200"
      data-aos-duration="1000"
    >
      {subtitle}
    </p>
  </header>
);

/* ============================================================
   FEATURE SPLIT
   ============================================================ */

const FeatureSplit = ({
  id,
  bg,
  reverse,
  pill,
  title,
  subtitle,
  image,
  tag,
  features,
}) => (
  <section id={id} className={`ib-sec ib-sec--${bg}`}>
    <div className="ib-container">
      <SectionHead
        pill={pill}
        title={title}
        subtitle={subtitle}
      />

      <div className={`ib-split ${reverse ? "is-reverse" : ""}`}>
        <div
          className="ib-split__media"
          data-aos={reverse ? "fade-left" : "fade-right"}
          data-aos-duration="1200"
          data-aos-easing="ease-out-cubic"
        >
          <Frame src={image} alt={title} tag={tag} />
        </div>

        <ul className="ib-features">
          {features.map(([name, text], index) => (
            <li
              key={name}
              className="ib-feature"
              data-aos="fade-up"
              data-aos-delay={index * 120}
              data-aos-duration="900"
            >
              <span className="ib-tick" aria-hidden="true">
                ✓
              </span>

              <div>
                <h3>{name}</h3>
                <p>{text}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);

/* ============================================================
   CONTENT
   ============================================================ */

const AUDIENCE = [
  {
    icon: "store",
    title: "Kirana & General Stores",
    text: "Fast billing, item tracking, and low-stock alerts.",
  },
  {
    icon: "phone",
    title: "Electronics & Mobile Shops",
    text: "IMEI/SKU tracking, camera product sync, and warranty/serial logging.",
  },
  {
    icon: "shirt",
    title: "Clothing & Apparel Stores",
    text: "Variant management, category filters, and quick POS checkout.",
  },
  {
    icon: "wrench",
    title: "Hardware & Electrical Stores",
    text: "Barcode scanning, multi-item invoicing, and quotation generation.",
  },
  {
    icon: "truck",
    title: "Wholesalers & Distributors",
    text: "Bulk import via CSV/Excel, delivery document archives, and ledger tracking.",
  },
];

const POS_FEATURES = [
  [
    "Product Image Sync",
    "Easy and fast product identification by syncing directly with product images.",
  ],
  [
    "Camera Integration",
    "Built-in mobile/device camera integration to capture and sync product images on the fly.",
  ],
  [
    "Product Cards & Category Filters",
    "Visual grid layout for fast item selection.",
  ],
  [
    "Favorites & SKU Search",
    "Instant lookup for top-selling items.",
  ],
  [
    "Barcode Scanner Support",
    "Seamless integration with USB and Bluetooth barcode scanners.",
  ],
  [
    "Multi-Item Invoices",
    "Add multiple items with customer details and automatic GST calculations instantly.",
  ],
];

const INVENTORY_FEATURES = [
  [
    "SKU & Pricing Control",
    "Maintain SKUs, selling prices, stock quantities, GST rates, and low-stock thresholds.",
  ],
  [
    "Automatic Stock Updates",
    "Deduct stock on sales, add incoming stock, and display instant low-stock alerts.",
  ],
  [
    "Bulk Inventory Import",
    "Effortlessly import stock data from CSV and Excel files.",
  ],
  [
    "Purchase Invoice OCR",
    "Extract printed English invoice data locally from images and review before updating stock.",
  ],
  [
    "Delivery Document Archive",
    "Retain original purchase images, references, review details, and confirmation status.",
  ],
];

const PAYMENT_FEATURES = [
  [
    "Quotation Generation",
    "Prepare multi-item quotations with GST without reducing available stock.",
  ],
  [
    "Flexible Invoice Output",
    "View invoices, download PDFs, and print A4 or dot-matrix layouts.",
  ],
  [
    "Payment Tracking",
    "Record full or partial payments, payment modes, receipt references, and outstanding balances.",
  ],
  [
    "UPI QR & WhatsApp Reminders",
    "Generation of balance-specific UPI QR codes, upload payment QR images, and open pre-formatted WhatsApp reminders.",
  ],
];

const DASHBOARD_FEATURES = [
  [
    "Live Dashboard",
    "Monitor sales, collections, pending amounts, stock levels, recent transactions, and sales trends.",
  ],
  [
    "Tax Preparation Support",
    "Generate monthly GST summaries, CSV exports, and simplified income/advance-tax estimates (designed for tax prep, not government filing).",
  ],
];

const ADMIN = [
  {
    icon: "headset",
    title: "24/7 Support",
    text: "Round-the-clock customer support to ensure your business operations never stop.",
  },
  {
    icon: "sliders",
    title: "Business Customization",
    text: "Configure shop branding, business type, address, tax identifiers, and bank details.",
  },
  {
    icon: "shield",
    title: "Shop & Platform Administration",
    text: "Separate shop accounts and data, customer transaction views, and host-admin enable/disable controls.",
  },
  {
    icon: "book",
    title: "Built-in Support",
    text: "Access the built-in illustrated manual, save suggestions/complaints for admin review, and explore simulated subscription checkouts.",
  },
];

const FAQS = [
  {
    q: "Is iTiXBiz really free to use?",
    a: "Yes! Offered completely free by Global Suntec as part of our commitment to supporting Digital India and empowering small businesses.",
  },
  {
    q: "Can I use my phone camera to add products?",
    a: "Absolutely. iTiXBiz features built-in camera integration so you can snap product photos and sync them instantly for fast identification.",
  },
  {
    q: "Does it support barcode scanners?",
    a: "Yes, it seamlessly integrates with both USB and Bluetooth barcode scanners for lightning-fast POS billing.",
  },
  {
    q: "Is my business data secure?",
    a: "Yes, iTiXBiz features separate shop accounts, tenant isolation, and secure data handling practices.",
  },
  {
    q: "Can I generate GST reports?",
    a: "Yes, you can generate monthly GST summaries and CSV exports to simplify your tax preparation.",
  },
];

/* ============================================================
   1. HERO
   ============================================================ */

const Hero = () => (
  <section className="ib-hero">
    <div className="ib-container ib-hero__grid">
      <div
        className="ib-hero__content"
        data-aos="fade-right"
        data-aos-duration="1200"
        data-aos-easing="ease-out-cubic"
      >
        <span
          className="ib-hero__badge"
          data-aos="fade-down"
          data-aos-delay="150"
        >
          Smart Inventory &amp; Billing for Modern Businesses
          <i />
          Supporting Digital India
          <em>Completely Free Offer by Global Suntec</em>
        </span>

        <h1
          className="ib-hero__title"
          data-aos="fade-up"
          data-aos-delay="250"
          data-aos-duration="1100"
        >
          Simplify Your Billing, Track Every Item, and Grow Your Business with{" "}
          <span>iTiXBiz</span>
        </h1>

        <p
          className="ib-hero__sub"
          data-aos="fade-up"
          data-aos-delay="350"
        >
          The all-in-one POS, inventory management, GST billing, and payment
          collection platform built for retail stores, wholesalers, and growing
          enterprises. Offered completely free by Global Suntec to support
          Digital India.
        </p>

        <div
          className="ib-hero__actions"
          data-aos="zoom-in"
          data-aos-delay="450"
        >
          <a href={LINKS.start} className="ib-btn ib-btn--primary">
            Get Started Free
          </a>

          <a href={LINKS.demo} className="ib-btn ib-btn--outline">
            Watch Live Demo
          </a>
        </div>
      </div>

      <div
        data-aos="fade-left"
        data-aos-duration="1300"
        data-aos-delay="200"
      >
        <Frame
          src={IMAGES.hero}
          alt="iTiXBix dashboard preview"
          tag="DASHBOARD"
        />
      </div>
    </div>
  </section>
);

/* ============================================================
   2. WHO IS IT FOR
   ============================================================ */

const Audience = () => (
  <section id="who" className="ib-sec ib-sec--white">
    <div className="ib-container">
      <SectionHead
        pill="WHO IS iTiXBiz FOR?"
        title="Built for Every Type of Retailer & Wholesaler"
        subtitle="Whether you run a small local shop or a growing enterprise, iTiXBix adapts to your business needs."
      />

      <div className="ib-cards">
        {AUDIENCE.map((a, i) => (
          <article
            className="ib-card"
            key={a.title}
            data-aos="fade-up"
            data-aos-delay={i * 150}
            data-aos-duration="1000"
          >
            <span className="ib-card__num" aria-hidden="true">
              {String(i + 1).padStart(2, "0")}
            </span>

            <span className="ib-icon">
              <Icon name={a.icon} />
            </span>

            <h3>{a.title}</h3>
            <p>{a.text}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

/* ============================================================
   8. ADMIN & SUPPORT
   ============================================================ */

const Admin = () => (
  <section id="support" className="ib-sec ib-sec--white">
    <div className="ib-container">
      <SectionHead
        pill="ADMINISTRATION & SUPPORT"
        title="Secure, Customizable & Round-the-Clock Support"
        subtitle="Tailor the platform to your brand with enterprise-grade data isolation and dedicated assistance."
      />

      <div className="ib-grid4">
        {ADMIN.map((a, i) => (
          <article
            className="ib-card ib-card--left"
            key={a.title}
            data-aos="zoom-in"
            data-aos-delay={i * 150}
            data-aos-duration="1000"
          >
            <span className="ib-icon">
              <Icon name={a.icon} />
            </span>

            <h3>{a.title}</h3>
            <p>{a.text}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

/* ============================================================
   9. FAQ
   ============================================================ */

const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="ib-sec ib-sec--blue">
      <div className="ib-container ib-container--narrow">
        <SectionHead
          pill="FAQ"
          title="Frequently Asked Questions"
          subtitle=""
        />

        <div className="ib-faq">
          {FAQS.map((f, i) => {
            const isOpen = open === i;

            return (
              <div
                key={f.q}
                className={`ib-faq__item ${isOpen ? "is-open" : ""}`}
                data-aos="fade-up"
                data-aos-delay={i * 100}
                data-aos-duration="900"
              >
                <h3>
                  <button
                    type="button"
                    className="ib-faq__q"
                    aria-expanded={isOpen}
                    aria-controls={`ib-faq-${i}`}
                    onClick={() => setOpen(isOpen ? null : i)}
                  >
                    <span className="ib-faq__n">
                      {String(i + 1).padStart(2, "0")}
                    </span>

                    <span className="ib-faq__t">{f.q}</span>

                    <span className="ib-faq__i" aria-hidden="true" />
                  </button>
                </h3>

                <div
                  id={`ib-faq-${i}`}
                  className="ib-faq__panel"
                  role="region"
                >
                  <div>
                    <p>{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

/* ============================================================
   CLOSING CTA
   ============================================================ */

const Cta = () => (
  <section className="ib-cta">
    <div
      className="ib-container ib-cta__inner"
      data-aos="zoom-in"
      data-aos-duration="1100"
      data-aos-easing="ease-out-cubic"
    >
      <h2>
        Simplify Your Billing, Track Every Item, and Grow Your Business with{" "}
        <span>iTiXBiz</span>
      </h2>

      <p>
        Completely free offer by Global Suntec, supporting Digital India.
      </p>

      <div className="ib-hero__actions ib-cta__actions">
        <a href={LINKS.start} className="ib-btn ib-btn--primary">
          Get Started Free
        </a>

        <a href={LINKS.demo} className="ib-btn ib-btn--ghost">
          Watch Live Demo
        </a>
      </div>
    </div>
  </section>
);

/* ============================================================
   PAGE
   ============================================================ */

const ITiXBixPage = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      delay: 100,
      offset: 100,
      easing: "ease-in-out",
      once: false,
      mirror: true,
      anchorPlacement: "top-bottom",
      disable: false,
    });

    AOS.refreshHard();

    const refreshAOS = () => {
      AOS.refresh();
    };

    window.addEventListener("load", refreshAOS);

    return () => {
      window.removeEventListener("load", refreshAOS);
    };
  }, []);

  return (
    <main className="ib-page">
      {/* HERO SECTION */}
      <div data-aos="fade-down" data-aos-duration="1000">
        <HeroSection />
      </div>

      <Hero />

      <Audience />

      {/* POS SECTION */}
      <div data-aos="fade-up" data-aos-duration="1100">
        <ITixpos />
      </div>

      {/* INVENTORY SECTION */}
      <FeatureSplit
        id="inventory"
        bg="white"
        reverse
        pill="INVENTORY & STOCK MANAGEMENT"
        title="Real-Time Inventory Control & Automation"
        subtitle="Never run out of stock or lose track of your inventory items again."
        image={IMAGES.inventory}
        tag="INVENTORY"
        features={INVENTORY_FEATURES}
      />

      {/* HOW IT WORKS */}
      <div data-aos="fade-up" data-aos-duration="1100">
        <HowItWorks />
      </div>

      {/* PAYMENTS SECTION */}
      <FeatureSplit
        id="payments"
        bg="white"
        pill="PAYMENTS, QUOTATIONS & WHATSAPP"
        title="Flexible Billing & Smart Collections"
        subtitle="Manage quotations, track payments, and collect dues faster via WhatsApp."
        image={IMAGES.payments}
        tag="PAYMENTS"
        features={PAYMENT_FEATURES}
      />

      {/* ANALYTICS SECTION */}
      <FeatureSplit
        id="analytics"
        bg="blue"
        reverse
        pill="BUSINESS DASHBOARD & ANALYTICS"
        title="Complete Business Visibility at a Glance"
        subtitle="Make informed decisions with real-time operational metrics and tax reports."
        image={IMAGES.dashboard}
        tag="ANALYTICS"
        features={DASHBOARD_FEATURES}
      />

      {/* ADMIN */}
      <Admin />

      {/* FAQ */}
      <Faq />

      {/* CTA */}
      <Cta />

      {/* FOOTER */}
      <div data-aos="fade-up" data-aos-duration="1000">
        <Gfooter />
      </div>
    </main>
      );
};
export default ITiXBixPage;